<template lang="pug">
  div.overflow-hidden
    div
      slot(name='top',v-bind:renderTools='renderTools')
    div.relative.flex.flex-col.overflow-hidden
      div(ref='canvas',:style='style')
      div
        slot(name='view',
          v-bind:renderTools='renderTools',
          v-bind:container='frozenContainer',
          v-bind:screenContainer='frozenScreenContainer',
          v-bind:canvas='this.$refs.canvas',
          v-bind:pixi-app='pixiApp')
        canvas-mask(
          :screen-container='frozenScreenContainer',
          :container='frozenContainer'
          :render-tools='renderTools'
          :size='size'
          :cache-as-bitmap='true'
        )
      div(v-if='loading')
        slot(name='loading')
</template>
<script>
import { sortBy } from 'lodash';
import { testHit } from '@edit/render/pixihammer.js';
import Hammer from 'hammerjs';
import CanvasMask from '@edit/atoms/CanvasMask.vue';
import RenderTools from '@edit/render/rendertools.js';
import FreezedContainer from '@edit/render/freezedcontainer.js';

export default {
  props:{
    unit:{
      type:Object,
      default() {
        return {
          x:8,
          y:8
        }
      }
    },
    size:{
      type:Object,
      default() {
        return {
          cols:9,
          rows:16
        }
      }
    },
    backgroundColor:{
      type:String,
      default:'#000000'
    },
    enableCanvasMask:{
      type:Boolean,
      default:true
    },
    forceCanvas:{
      type:Boolean,
      default:false
    },
    layers:{
      type:Object,
      required:true
    },
    enablePanning: {
      type:Boolean,
      default: true
    }
  },
  components: {
    CanvasMask
  },
  data() {
    const container = new PIXI.Container();
    const screenContainer = new PIXI.Container();
    const frozenContainer = new FreezedContainer(container);
    const frozenScreenContainer = new FreezedContainer(screenContainer);
    //const width = 128;
    //const height = 128;
    const pixiApp = new PIXI.Application({
      //width,
      //height,
      transparent:false,
      autoResize:true,
      antialias: true,
      forceFXAA: true,
      resolution: 1,
      forceCanvas:this.forceCanvas,
    })
    pixiApp.ticker.add(this.ticker.bind(this));

    // actually want a single RenderTools
    const renderTools = new RenderTools(container, this.layers, this.size);
    renderTools.on('start', this.renderStart.bind(this));
    renderTools.on('stop', this.renderStop.bind(this));
    renderTools.on('update', this.renderUpdate.bind(this));
    renderTools.setupApp(pixiApp);

    this.$store.commit('setRenderTools', renderTools);

    return {
      renderTools,
      container,
      screenContainer,
      frozenContainer,
      frozenScreenContainer,
      pixiApp,
      renderCounter:0,
      loading:false,
      x:0,
      y:0,
      canvasElement:null
    }
  },
  methods:{
    onPinchStart(e) {
      this.$emit('pinchstart', e);
    },
    onPinchMove(e) {
      this.$emit('pinchmove', e);
    },
    onPinchEnd(e) {
      this.$emit('pinchend', e);
    },
    onMouseWheel(e) {
      this.$emit('mousewheel', e)
    },
    onPanStart(e) {
      this.$emit("panstart", e);
      this.onShortPressUp({cancel:true});
    },
    onPanMove(e) {
      this.$emit("panmove", e);
    },
    onPanEnd(e) {
      this.$emit("panend", e);
    },
    ticker() {
      if (this.renderTools.onRenderStart) {
        this.renderTools.onRenderStart();
      }
      //if (this.meter) {
        //this.meter.tickStart();
      //}
      this.renderCounter--;
      if (this.renderCounter <= 0) {
        this.pixiApp.stop();
      }
      if (this.renderTools.onRenderEnd) {
        this.renderTools.onRenderEnd();
      }

    },
    renderUpdate() {
      if (this.renderCounter <= 0) {
        this.pixiApp.start();
      }
      this.renderCounter = 20;
    },
    renderStart() {
      this.render();
      this.loading = true;
      this.$emit('start', {
        container:this.container,
        pixiApp:this.pixiApp,
        canvas:this.$refs.canvas
      });
    },
    renderStop() {
      this.loading = false;
      this.$emit('stop', {
        container:this.container,
        pixiApp:this.pixiApp,
        canvas:this.$refs.canvas,
        renderTools:this.renderTools
      });

      //this.container.cacheAsBitmap = false;
    },
    render() {
      this.renderCounter = 20;
      this.pixiApp.start();
    },
    getDimensions() {
      if (!this.$el) {
        return {
          width:128,
          height:128
        }
      }
      const el = this.$el;
      let bb = el.getBoundingClientRect();
      const boundingBox = {
        width:bb.width,
        top:bb.top,
        left:bb.left,
        right:bb.right,
        bottom:bb.bottom,
        height:bb.height,
      }


      const topOffset = bb.top;
      const height = Math.max(bb.height,32);
      const width = Math.max(bb.width,32);
      return {
        height,
        width
      }
    },
    enableInteraction() {
      if (!this.stageInteractive) {
        this.stageInteractive = new PIXI.Container();
        this.stageInteractive.hitArea = new PIXI.Rectangle(-10000, -10000, 20000, 20000);
        this.stageInteractive.interactive = true;
        this.stageInteractive.__pbc_is_stage = true;
        this.stageInteractive.__zindex = Number.MIN_SAFE_INTEGER;

        this.pixiApp.stage.addChild(this.stageInteractive);

        this.renderTools.setStageInteractive(this.stageInteractive);
        this.renderTools.setZIndex(this.stageInteractive, 'default', -9999);

        const el = this.$refs.canvas;
        this.hammer = new Hammer.Manager(el, {
          touchAction:'none'
        })

        const pan = new Hammer.Pan({
          threshold:25,
          pointers:1
        })


        const shortPress = new Hammer.Press({
          event:'shortpress',
          time: 60
        });
        const tap = new Hammer.Tap({
        });
        //press.requireFailure([pan]);
        //press.requireFailure([tap]);
        
        /*
        const pinch = new Hammer.Pinch({
          threshold:0.1
        })
        */
        /*
        const swipe =  new Hammer.Swipe({
          threshold:5,
          velocity:0.15
        })
        */
        this.hammer.add(pan);
        this.hammer.add(tap);
        this.hammer.add(shortPress);
        /*
        this.hammer.add(swipe)
        */
        this.hammer.on('tap', this.onTap);

        // this sometimes leaves a blue thing :-(
        //const press = new Hammer.Press({
        //});
        //this.hammer.add(press);
        //this.hammer.on('press', this.onPress);
        //this.hammer.on('pressup', this.onPressUp);

        this.hammer.on('shortpress', this.onShortPress);
        this.hammer.on('shortpressup', this.onShortPressUp);

        this.hammer.on('panstart', this.onPanStartDrag);
        this.hammer.on('panmove', this.onPanMoveDrag);
        this.hammer.on('panend', this.onPanEndDrag);

        el.addEventListener('mousewheel', this.onMouseWheel);
      }
      this.pixiApp.renderer.plugins.interaction = new PIXI.InteractionManager(this.pixiApp.renderer);
    },
    //onTap({srcEvent: {offsetX, offsetY}}) {
    onTap(e) {
      const {offsetX, offsetY} = this.hackOffsetBecauseFirefoxSucks(e);

      this.selectionsStart();
      const touched = this.sendHammerEvent('hammertap', {
        x:offsetX,
        y:offsetY
      });
      this.selectionsEnd();

    },
    onPress(e) {
      const {offsetX, offsetY} = this.hackOffsetBecauseFirefoxSucks(e);
      this.longPressed = this.sendHammerEventToTopZindex('hammerpress', {x:offsetX,y:offsetY});
    },
    onPressUp(e) {
      const {offsetX, offsetY} = this.hackOffsetBecauseFirefoxSucks(e);
      (this.longPressed||[]).forEach( (touched) => {
        touched.emit('hammerpressup', event);
      });
      this.longPressed = [];
    },
    onPanStartDrag(e) {
      const {offsetX, offsetY} = this.hackOffsetBecauseFirefoxSucks(e);
      (this.shortPressed||[]).forEach( (touched) => {
        touched.emit('hammerpanstart', {x:offsetX,y:offsetY});
      });
      //const dragging = this.sendHammerEventToTopZindex('hammerpanstart', {x:offsetX,y:offsetY});
      this.busyDragging = this.shortPressed;
      this.dragStart = {
        x:offsetX,
        y:offsetY
      }
    },
    onPanMoveDrag(e) {
      if (typeof(this.busyDragging) === 'undefined') {
        return;
      }
      const {offsetX, offsetY} = this.hackOffsetBecauseFirefoxSucks(e);

      const deltaX = offsetX - this.dragStart.x;
      const deltaY = offsetY - this.dragStart.y;
      this.busyDragging.forEach( (dragging) => {
        dragging.emit('hammerpanmove', {
          deltaX,
          deltaY
        });
      });
      this.dragStart.x += deltaX;
      this.dragStart.y += deltaY;
    },
    onPanEndDrag(e) {
      if (typeof(this.busyDragging) === 'undefined') {
        return;
      }
      const {offsetX, offsetY} = this.hackOffsetBecauseFirefoxSucks(e);
      this.busyDragging.forEach( (dragging) => {
        dragging.emit('hammerpanend', {
          x:offsetX,
          y:offsetY
        });
      });
      this.busyDragging = [];
    },
    onShortPress(e) {
      const {offsetX, offsetY} = this.hackOffsetBecauseFirefoxSucks(e);
      this.shortPressed = this.sendHammerEventToTopZindex('hammershortpress', {x:offsetX,y:offsetY});
    },
    onShortPressUp({cancel,srcEvent}) {
      if (this.shortPressed && this.shortPressed.length) {
        if (!cancel) {
          this.selectionsStart();
        }
        this.shortPressed.forEach( (touched) => {
          touched.emit("hammershortpressup", srcEvent);
          //if (!cancel && srcEvent) {
            //touched.emit('hammertap', srcEvent);
          //}
        });
        if (!cancel) {
          this.selectionsEnd();
        }
        this.shortPressed = [];
      }
      //this.selectionsEnd();
    },
    sendHammerEvent(event, {x,y}) {
      const touched = [];
      testHit(this.pixiApp.stage, {x,y}, touched);
      touched.forEach( (t) => {
        t.emit(event,{
          x,
          y,
          cancelSelection:() => {
            this.selectionsStart();
          },
          hits:touched.filter( (t) => { return !isNaN(parseFloat(t.__zindex)); } )
        });
      });
      return touched;
    },
    sendHammerEventToTopZindex(event, {x,y}) {
      let touched = [];
      testHit(this.pixiApp.stage, {x,y}, touched);
      touched = sortBy(touched.filter( 
        (container) => { return typeof(container.__zindex) !== 'undefined' }
      ), (container) => {
        return container.__zindex;
      });
      touched.reverse();
      if (touched.length) {
        touched = [touched[0]];
      }
      touched.forEach( (touched) => {
        touched.emit(event, {x,y});
      });
      return touched;
    },

    disableInteraction() {
      this.pixiApp.renderer.plugins.interaction.destroy();
    },
    setCanvasSize(width,height) {
      return new Promise( (resolve, reject) => {
        window.requestAnimationFrame( () => {
          this.pixiApp.renderer.resize(width,height);
          this.render();
          resolve();
        });
      });
    },
    resizeCanvas() {
      //this.$refs.canvas.style.display = 'none';

      this.pixiApp.stop();
      return new Promise( (resolve, reject) => {
        window.requestAnimationFrame( () => {
          const dims = this.getDimensions();
          const {width,height} = dims;

          //this.$refs.canvas.style.display = 'block';

          if (height < 100) {
            return;
          }

          this.pixiApp.renderer.resize(width,height);
          this.pixiApp.stage.position.set(width/2, height/2);
          this.setScale(width, height);
          this.render();
          resolve();
        });
      });
    },
    selectionsStart() {
      this.$emit('selections-start');
    },
    selectionsEnd() {
      this.$emit('selections-end');
    },
    hackOffsetBecauseFirefoxSucks({center:{x,y}}) {

      const el = this.canvasElement;
      const bb = el.getBoundingClientRect();

      return {
        offsetX: x - bb.left,
        offsetY: y - bb.top
      }
    },
    getScale(width, height) {
      //console.log('setSCALE', width, height);

      const cols = this.size.cols;
      const rows = this.size.rows;
      
      if (width < height) {
        /*
        let hax = 1080;
        if (width/height < 0.7) {
          hax = 1180;
        }
        if (width/height < 0.6) {
          hax = 1380;
        }
        */
        const scale = Math.min(
          width / cols / (1920/16),
          height / rows / (1080/9), // lol iphone x?!?!?
          Math.max(
            width / rows / (1080/9),
            height / cols / (1920/16)
          )
        );
        return scale;
      } else {
        const scale = Math.min(
          width / cols / (1080/9),
          height / rows / (1920/16),
          width / rows / (1920/9),
          height / cols / (1280/16)
        );
        return scale;
      }

    },
    setScale(width, height) {
      const scale = this.getScale(width, height);
      this.pixiApp.stage.scale.set(scale, scale);
    }

  },
  computed:{
    style() {
      return {
        'background-color':this.backgroundColor
      }
    },
    canvas() {
      return this.$refs.canvas;
    }
  },
  mounted() {
    this.canvasElement = this.$refs.canvas;

    const dims = this.getDimensions();
    const {width,height} = dims;

    this.pixiApp.renderer.resize(width,height);
    this.pixiApp.renderer.backgroundColor = parseInt(this.backgroundColor.replace('#','0x'));
    if (this.pixiApp.renderer.plugins.interaction) {
      this.pixiApp.renderer.plugins.interaction.destroy();
    }
    //this.pixiApp.stage = new PIXI.Stage();
    //this.pixiApp.stage.group.enableSort = true;
    this.$refs.canvas.appendChild(this.pixiApp.view);

    this.pixiApp.stage.position.set(width/2, height/2);
    //this.container.scale.set(this.unit.x * 10,this.unit.y * 10);
    //this.container.scale.set(1.4,1.4);

    this.setScale(width, height);
    //this.container.pivot.set(0, 0);

    this.pixiApp.stage.addChild(this.container);

    this.pixiApp.stage.addChild(this.screenContainer);
    this.renderTools.setZIndex(this.screenContainer, 'text', 10000);

  },
  beforeDestroy() {
    if (this.renderTools) {
      this.renderTools.off('start');
      this.renderTools.off('stop');
      this.renderTools.off('update');
      this.renderTools.destroy();
    }
    if (this.hammer) {
      this.hammer.destroy();
    }
    const el = this.$el.querySelector('canvas');
    if (el) {
      el.removeEventListener('mousewheel', this.onMouseWheel);
    }
    if (this.pixiApp) {
      this.pixiApp.destroy({
        removeView: true,
        stageOptions: {
          children: true,
          texture: true,
          baseTexture: true
        }
      });

    }
  },
  watch: {
    size: {
      handler(nv) {
        this.resizeCanvas();
        this.renderTools.updateCanvasSize(nv);
      },
      deep:true
    },
    backgroundColor() {
      this.pixiApp.renderer.backgroundColor = parseInt(this.backgroundColor.replace('#','0x'));
      this.render();
    },
    enablePanning(nv) {
      if (nv) {
        this.hammer.on('panstart', this.onPanStart);
        this.hammer.on('panmove', this.onPanMove);
        this.hammer.on('panend', this.onPanEnd);
      } else {
        this.hammer.off('panstart', this.onPanStart);
        this.hammer.off('panmove', this.onPanMove);
        this.hammer.off('panend', this.onPanEnd);
      }

    }
  }
}
</script>
